import React from 'react';
import CloseIcon from '@atlaskit/icon/core/migration/cross-circle';
import SearchIcon from '@atlaskit/icon/core/migration/search';
import { Box, xcss } from '@atlaskit/primitives';
import { components } from '@atlaskit/select';
var customDropdownIndicatorStyles = xcss({
  display: 'flex',
  cursor: 'pointer',
  justifyContent: 'center',
  width: "var(--ds-space-400, 32px)"
});
var CustomDropdownIndicator = function CustomDropdownIndicator(props) {
  var selectProps = props.selectProps;
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement(Box, {
    xcss: customDropdownIndicatorStyles,
    onClick: function onClick() {
      if (selectProps.inputValue) {
        selectProps.onInputChange && selectProps.onInputChange('', {
          action: 'input-change',
          prevInputValue: selectProps.inputValue
        });
      }
    }
  }, selectProps.inputValue ? /*#__PURE__*/React.createElement(CloseIcon, {
    LEGACY_size: "small",
    label: "",
    color: "currentColor"
  }) : /*#__PURE__*/React.createElement(SearchIcon, {
    LEGACY_size: "small",
    label: "",
    color: "currentColor"
  })));
};
export default CustomDropdownIndicator;